import { Create, List, Edit } from "../Components/index.js";

export default [
    {
        path: "/training",
        component: List,
        name: "training-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/create",
        component: Create,
        name: "training-create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/:id/edit",
        component: Edit,
        name: "training-edit",
        meta: {
            requiresAuth: true,
        },
    },
];
